import { h } from "preact";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
import FieldLabel from "./FieldLabel";
function TextField(props) {
    const { controller, name, label, type = "text", autocomplete, placeholder, required = false, disabled = false, autofocus = false, dataFieldId, } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        controller.change(value);
    };
    const hasError = controller.isTouched && controller.isInvalid;
    const isSuccess = controller.isTouched && controller.isValid;
    return (
    // TODO: wchich is proper class? form-field or m-form__group? (are used alternately)
    // TODO: export <FormField> component for TextField, PhoneField (and more...?)
    h("div", { class: `form-group m_form-group form-field ${hasError ? "has-error" : ""} ${isSuccess ? "success" : ""} ${disabled ? "is-disabled" : ""}`, "data-field-id": dataFieldId },
        h(FieldLabel, { isRequired: required, htmlFor: name }, label),
        h("input", { id: name, name: name, onChange: handleChange, onBlur: () => controller.blur(), value: controller.value, type: type, autofocus: autofocus, autocomplete: autocomplete, placeholder: placeholder, required: required, disabled: disabled, class: "form-control u-text-normal" }),
        hasError && h(FieldError, { errors: controller.errors })));
}
export default observer(TextField);
